import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './CheckBoatModal.module.css';

const CheckinIcon = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.checkinIcon, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      height="48"
      width="48"
      viewBox="0 0 48 48"
    >
      <path d="M3.5 13.5h-2a1 1 0 0 1-1-1v-8h13v8a1 1 0 0 1-1 1h-2" transform="scale(3.42857)" />
      <path
        d="M4.5 10 7 7.5 9.5 10M7 7.5v6M11.29 1a1 1 0 0 0-.84-.5h-6.9a1 1 0 0 0-.84.5L.5 4.5h13ZM7 .5v4"
        transform="scale(3.42857)"
      />
    </svg>
  );
};

const { string } = PropTypes;

CheckinIcon.defaultProps = {
  className: null,
  rootClassName: null,
};

CheckinIcon.propTypes = {
  className: string,
  rootClassName: string,
};

export default CheckinIcon;
